import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { ClientConfigProductName, ProductService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class PromoDeactivateGuard implements CanDeactivate<any> {
    constructor(private productService: ProductService) {}

    canDeactivate() {
        this.productService.deactivateProduct(ClientConfigProductName.PROMO);
        dispatchEvent(new CustomEvent('gs:hideHeaderEntry'));
        dispatchEvent(new CustomEvent('gs:hideFloatingEntry'));

        return true;
    }
}
